import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/anime";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "ok" | "error">("idle");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("company_alt") || "").trim();
    setLoading(true);
    setStatus("idle");

    if (honeypot !== "") {
      setStatus("ok");
      setMsg("订阅成功，每周精选片单已整装待发！");
      setLoading(false);
      form.reset();
      return;
    }

    try {
      const res = await fetch("https://readdy.ai/api/form/da1baq9st185ek8aso60", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        (parsed as any)?.meta?.message ||
        (parsed as any)?.message ||
        (parsed as any)?.meta?.detail ||
        responseText;
      if (res.ok && (parsed as any)?.code === "OK") {
        setStatus("ok");
        setMsg("订阅成功，每周精选片单已整装待发！");
        form.reset();
      } else {
        setStatus("error");
        setMsg(String(serverMsg || "订阅失败，请稍后再试"));
      }
    } catch (err) {
      setStatus("error");
      setMsg("网络异常，订阅失败，请稍后再试");
    } finally {
      setLoading(false);
    }
  }

  return (
    <footer className="mt-16">
      {/* 订阅横幅 */}
      <div className="bg-primary-500">
        <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-12">
          <div className="flex flex-col items-center gap-4 text-center">
            <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50">
              每周五更新 · 精选片单直达
            </span>
            <h2 className="font-display text-2xl text-background-50 md:text-3xl">
              订阅「小虎片单」，告别剧荒
            </h2>
            <p className="max-w-xl text-sm text-background-50/85">
              输入邮箱即可每周收到小虎精选的高分番、冷门佳作与熬夜补番清单，不错过任何一部好番。
            </p>
            <form
              data-readdy-form="订阅"
              onSubmit={onSubmit}
              className="mt-2 flex w-full max-w-md flex-col gap-3 sm:flex-row"
            >
              <label htmlFor="nl-email" className="sr-only">
                邮箱
              </label>
              <input
                id="nl-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱"
                className="h-11 flex-1 rounded-md border border-background-200 bg-background-50 px-4 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="xh-honeypot"
              />
              <button
                type="submit"
                disabled={loading}
                className="h-11 whitespace-nowrap rounded-md bg-foreground-900 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-950 disabled:opacity-60"
              >
                {loading ? "订阅中…" : "立即订阅"}
              </button>
            </form>
            {status === "ok" && (
              <p className="text-sm text-background-50">{msg}</p>
            )}
            {status === "error" && (
              <p className="text-sm text-accent-200">{msg}</p>
            )}
          </div>
        </div>
      </div>

      {/* 页脚主体 */}
      <div className="bg-primary-950 text-background-100">
        <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
          <div className="grid gap-8 md:grid-cols-12">
            <div className="md:col-span-5">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
                </span>
                <span className="font-display text-2xl">小虎看番</span>
              </div>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
                小虎看番是专注补番推荐的动画片单站。高分番列表、冷门佳作、完结番合集与熬夜补番清单，
                一只老虎帮你挑好番，从此告别剧荒。
              </p>
              <div className="mt-5 flex items-center gap-3">
                <a
                  href="#"
                  aria-label="微博"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
                >
                  <i className="ri-weibo-fill text-lg" aria-hidden="true"></i>
                </a>
                <a
                  href="#"
                  aria-label="哔哩哔哩"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
                >
                  <i className="ri-play-circle-fill text-lg" aria-hidden="true"></i>
                </a>
                <a
                  href="#"
                  aria-label="公众号"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
                >
                  <i className="ri-wechat-fill text-lg" aria-hidden="true"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h3 className="text-sm font-semibold text-background-50">片单分类</h3>
              <ul className="mt-4 space-y-2.5">
                {categories.map((c) => (
                  <li key={c.id}>
                    <Link
                      to={c.path}
                      className="text-sm text-background-200/80 transition-colors hover:text-accent-300"
                    >
                      {c.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h3 className="text-sm font-semibold text-background-50">网站导航</h3>
              <ul className="mt-4 space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-200/80 hover:text-accent-300">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-200/80 hover:text-accent-300">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/about#faq" className="text-sm text-background-200/80 hover:text-accent-300">
                    常见问题
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h3 className="text-sm font-semibold text-background-50">联系我们</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
                <li>
                  <a
                    href="mailto:hello@xiaohu-kanfan.example"
                    className="inline-flex items-center gap-2 hover:text-accent-300"
                  >
                    <i className="ri-mail-line" aria-hidden="true"></i>hi@xiaohu.fan
                  </a>
                </li>
                <li>
                  <span className="inline-flex items-center gap-2">
                    <i className="ri-time-line" aria-hidden="true"></i>每日 09:00 - 23:00
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-200/70 sm:flex-row">
            <p>© {new Date().getFullYear()} 小虎看番 · 用心整理每一部值得看的好番</p>
            <p>本片单仅作内容推荐参考</p>
          </div>
        </div>
      </div>
    </footer>
  );
}